const STORAGE_KEY = 'mock-session-user-id-v1';
const hasLocalStorage = () => typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
const readPersisted = () => {
    if (!hasLocalStorage())
        return undefined;
    return window.localStorage.getItem(STORAGE_KEY) ?? undefined;
};
const writePersisted = (id) => {
    if (!hasLocalStorage())
        return;
    if (id)
        window.localStorage.setItem(STORAGE_KEY, id);
    else
        window.localStorage.removeItem(STORAGE_KEY);
};
let currentUserId = readPersisted();
export const setMockCurrentUserId = (id) => {
    currentUserId = id;
    writePersisted(id);
};
export const getMockCurrentUserId = () => {
    return currentUserId;
};
export const resetMockSession = () => {
    currentUserId = undefined;
    writePersisted(undefined);
};
